module.exports = {"id":"176619","name":"Adrián Ramos","rating":"76","photo":"./data/images/photos/2/176619.png","club":{"name":"Grenade CF","logo":"./data/images/clubs/GrenadeCF.png"},"positions":["BU","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdrianRamos0.json
// module id = 110
// module chunks = 0